export default __webpack_public_path__ + "static/media/small_head_-10.86f24204.webp";